import React from "react";

const RaindropTextParagraph = ({ isFluid = true, children }) => {
  let tailwindWidth = "w-fit";
  if (isFluid) {
    tailwindWidth = "w-full";
  }

  return (
    <p
      className={`${tailwindWidth} text-lg text-left font-semibold text-color-text-primary dark:text-color-dark-text-primary`}
    >
      {children}
    </p>
  );
};

export default RaindropTextParagraph;
